import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { PlaylistsSharingGetAccessButton } from './playlistsSharing/PlaylistsSharingGetAccessButton';
import { nextAsset } from '../../components/nextAsset';

export const SmartlinksBrand: React.FC<{ subPageName: string }> = ({ subPageName }) => {
  const intl = useIntl();

  return (
    <div className="smartlinks-brand bg-primary">
      <Container className="py-5">
        <Row>
          <Col xs={12} className="d-flex d-lg-none justify-content-center">
            <img src={nextAsset('images/smartLinks/artist/brand.png')} alt="MR eazi brand" className="img-fluid" />
          </Col>
          <Col>
            <h2 className="main-header pt-5 pb-3 text-white text-center text-lg-start">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.brand.title',
                defaultMessage: 'Build your brand'
              })}
            </h2>
            <p className="header-subtitle">
              {intl.formatMessage(
                {
                  id: 'sml.web.smartlinks.brand.description',
                  defaultMessage:
                    'Establish your brand and look like a pro with minimum effort. {subPageName} is super easy to set up and customize.'
                },
                {
                  subPageName
                }
              )}
            </p>
            <ul className="fa-ul pt-5">
              <li className="lead text-white pb-4">
                <span className="fa-li text-secondary">
                  <FontAwesomeIcon icon={faSquare} />
                </span>
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.artist.brand.automatically',
                  defaultMessage: 'Automatically generate a professional microsite'
                })}
              </li>
              <li className="lead text-white pb-4">
                <span className="fa-li text-secondary">
                  <FontAwesomeIcon icon={faSquare} />
                </span>
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.artist.brand.personalize',
                  defaultMessage: 'Personalize its look and feel'
                })}
              </li>
              <li className="lead text-white pb-4">
                <span className="fa-li text-secondary">
                  <FontAwesomeIcon icon={faSquare} />
                </span>
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.artist.brand.customize',
                  defaultMessage: 'Customize your URL'
                })}
              </li>
            </ul>
            <div className="d-flex justify-content-center justify-content-lg-start ps-4">
              <PlaylistsSharingGetAccessButton
                className="text-white text-center align-items-center"
                isHighlighted
                source={`${subPageName} Build Your Brand`}
              />
            </div>
          </Col>
          <Col className="d-none d-lg-block pt-5">
            <img src={nextAsset('images/smartLinks/artist/brand.png')} alt="Mr Eazi brand" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
